import React, {useEffect, useMemo, useRef, useState} from 'react'
import Select, {ActionMeta} from 'react-select'
import {ApiUrbit} from '../../../../../../../infra/http/urbit'

type Props = {
  itensSelected?: any[] | null
  onChange?: any
  returnFull?: boolean
}

type Incorporadoras = {
  developer_id: number
  nome: string
  logo: string
  id: number
}

export interface Options {
  readonly value: string
  readonly label: string
  readonly developer_id?: number
  readonly nome?: string
  readonly logo?: string
  readonly color?: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}
export const SelectIncorporadoras: React.FC<Props> = ({
  itensSelected,
  onChange,
  returnFull = false,
}) => {
  const [incorporadoras, setIncorporadoras] = useState<Incorporadoras[]>([])
  const onChangeRef = useRef(onChange)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await ApiUrbit.get('service/lancamentos-incorporadoras')
        if (Array.isArray(response)) {
          setIncorporadoras(response)
        } else if (Array.isArray(response?.itens)) {
          setIncorporadoras(response.itens)
        } else {
          setIncorporadoras([])
        }
      } catch (error) {
        console.error('Erro ao buscar os dados:', error)
        setIncorporadoras([])
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    onChangeRef.current = onChange
  }, [onChange])
  const options = useMemo(
    () =>
      incorporadoras.map((item) => ({
        label: item.nome,
        value: item.nome,
        developer_id: item.developer_id,
        nome: item.nome,
        logo: item.logo,
      })),
    [incorporadoras]
  )

  const [selected, setSelected] = useState<Options[]>([])

  useEffect(() => {
    if (!onChangeRef.current) {
      return
    }
    const itens = selected.map((item) => {
      if (returnFull) {
        return {
          developer_id: item.developer_id,
          nome: item.nome,
          logo: item.logo,
        }
      }
      return item.value
    })
    onChangeRef.current(itens)
  }, [selected, returnFull])

  useEffect(() => {
    if (itensSelected) {
      const residencialSelecionados = options.filter((itens) => {
        return itensSelected.indexOf(itens.value) !== -1 ? true : false
      })
      const hasSameSelection =
        residencialSelecionados.length === selected.length &&
        residencialSelecionados.every((item, index) => item.value === selected[index]?.value)
      if (!hasSameSelection) {
        setSelected(residencialSelecionados)
      }
    } else if (selected.length) {
      setSelected([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itensSelected, options])

  return (
    <>
      <Select
        options={options}
        isMulti
        onChange={(option: Options[], actionMeta: ActionMeta<Options>) => {
          setSelected(option)
        }}
        value={selected}
      />
    </>
  )
}
